import CHANNELS from '../../../constants/Channels'
import { ConnectedMarketAccount } from '../../../current/types'

interface TrackBulkReviewClickProps {
  marketName: string
  count: number
  connectedMarketAccounts: ConnectedMarketAccount[]
  marketAccountId?: number
  tab: string
}

export function trackBulkReviewClickEvent({
  marketName = 'unknown',
  marketAccountId,
  connectedMarketAccounts = [],
  count,
  tab
}: TrackBulkReviewClickProps) {
  let channelName = marketName
  const matchedAccount: ConnectedMarketAccount = connectedMarketAccounts.find(marketAccount => {
    if (marketAccountId) {
      return marketAccount.id === marketAccountId && marketAccount.marketId === CHANNELS[marketName.toUpperCase()].id
    }

    return marketAccount.marketId === CHANNELS[marketName.toUpperCase()].id
  })

  if (matchedAccount) {
    channelName = matchedAccount.fullHumanReadableName
  }

  const trackingName = 'Review Bulk Action Clicked'
  const trackingData = {
    listingsCount: count,
    channelName,
    tab
  }

  analytics.track(trackingName, trackingData)
}
